import { render, staticRenderFns } from "./MetodoPagamento.vue?vue&type=template&id=021a3a8e"
import script from "./MetodoPagamento.vue?vue&type=script&lang=js"
export * from "./MetodoPagamento.vue?vue&type=script&lang=js"
import style0 from "./MetodoPagamento.vue?vue&type=style&index=0&id=021a3a8e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports